export const titles={
};

export const labels = {
    insertUser: 'Informe seu usuário',
    helloUser: "Olá, ",
    blankPage: "Blank page",
    logout: "Logout",
    login: "Acessar",
    registration: "Usuário de Rede",
    password: "Senha",
    userControl: 'Controle de usuários',
    userRegistration: 'Cadastro de usuários',
    userName: 'Nome do usuário',
    userRegister:'Matrícula do usuário',
    userEmail:'Email',
    userCResp:'Centro de custo',
    userNumEmp:'Número SAP',
    plate: 'Placa',
    users: 'Usuários',
    name: 'Nome',
    type: 'Tipo',
    profile: 'Perfil',
    model: 'Modelo',
    market: 'Mercado',
    search: 'Buscar',
    newPlate: 'Nova Placa',
    save: 'Salvar',
    cancel: 'Cancelar',
    back: 'Voltar',
    action: 'Ação',
    all: 'Todos',
    active: 'Ativo',
    inactive: 'Inativo',
    status: 'Situação',
    vehicle: 'Veículo',
    plateVehicle: 'Placa do veículo',
    groups: 'Grupos',
    groupsTesis: 'Grupos Tesis',
    componentsTesis: 'Componentes Tesis',
    cstGroups: 'Grupos CST',
    newGroup: 'Novo Grupo',
    editionGroup: 'Edição de Grupo',
    selectGroup: 'Qual grupo você deseja selecionar? ',
    selectSubGroup: 'Qual subgrupo você deseja selecionar? ',
    groupAliasPT:'Nomeie o seu grupo',
    groupAliasUS:'Nome do grupo em Inglês',
    groupAliasES:'Nome do grupo em Espanhol',
    groupSelectedLabel: 'Você escolheu o grupo: ',
    subGroupSelectedLabel: 'Você escolheu o subgrupo: ',
    selectGroupPlaceHolder: "Selecione o grupo",
    selectSubGroupPlaceHolder: "Selecione o subgrupo",
    selectItem: 'Qual item você deseja selecionar? ',
    itemSelectedLabel: 'Você escolheu o item: ',
    selectItemPlaceHolder: "Selecione um item",
    itemAliasPT:'Nomeie o seu item',
    itemAliasUS:'Nome do item em Inglês',
    itemAliasES:'Nome do item em Espanhol',
    youEditingItemFromGroup: 'Você está editando os Itens do Grupo:',
    anomalySelectedLabel: 'Você escolheu a anomalia: ',
    selectAnomaly: 'Qual anomalia você deseja selecionar? ',
    selectAnomalyPlaceHolder: 'Selecione uma anomalia',
    yourItems: 'Seus itens:',
    yourAnamolies: "Suas anomalias:",
    anomalyAliasPT:'Nomeie a sua Anomalia',
    anomalyAliasUS:'Nome da Anomalia em Inglês',
    anomalyAliasES:'Nome da Anomalia em Espanhol',
    addNewItem: 'Adicionar novo item:',
    removeItem: 'Deletar item',
    addFirstItemToGroup: 'Adicione o primeiro Item para seu grupo: ',
    editItem: 'Editar item',
    addNewAnomaly: 'Adicionar nova anomalia:',
    addFirstAnomalyToClaimed: 'Adicione a primeira Anomalia para seu Item: ',
    anomaly: 'Anomalia',
    editAnomaly: 'Editar Anomalia',
    removeAnomaly: 'Remover Anomalia',
    editGroup: 'Editar Grupo',
    removeGroup: 'Remover Grupo',
    editUser: 'Editar Usuário',
    removeUser: 'Remover Usuário',
    activeGroup: 'Ativar Grupo',
    experiences: 'Experiências',
    experiencesUser: 'Experiências de Usuário',
    creationDate : 'Data de Criação',
    statusDate: 'Data do Status',
    updateDate: 'Data de Atualização',
    claimedItem: 'Item Reclamado',
    experiencesReview: 'Revisão de Experiências',
    year: 'Ano',
    fuelType: 'Tipo de Combustível',
    originalDescription: 'Descrição da Experiência',
    revisionDescription: 'Revisão da Experiência',
    cancelExperience: 'Cancelar experiência',
    saveReview: 'Salvar revisão',
    newUser: 'Novo Usuário',
    download: 'Download',

    /*DataTable Information*/
    applyLabel : "Aplicar",
    cancelLabel: "Cancelar",
    monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro" ],
    daysOfWeek: ["D","S","T","Q","Q","S","S"],
    customRangeLabel: "Intervalo Personalizado",
};

export const messages = {
    requestError500: "Erro interno durante a requisição",
    requestError404: "Erro ao conectar no Servidor",
    requestError501: "Erro requisição não implementada",
    requestErrorDefault: "Erro durante a requisição",
    userEmptyError: "Por favor, digite um usuário",
    passwordEmptyError: "Por favor, digite uma senha",
    registration: "Digite sua matrícula",
    password: "Digite sua senha",
    loginError: "Ocorreu um erro durante o login, tente novamente",
    userSaved: 'Usuário salvo com sucesso!',
    selectMarket: 'Selecione o mercado antes de digitar a placa',
    plateInvalid: 'Placa inválida',
    userInvalid: 'Matrícula de rede inválida',
    cancelEdit: 'Tem certeza que deseja cancelar suas alterações?',
    emptyData: 'Pesquisa não retornou dados',
    errorURLEndpoint: 'Erro ao montar URL do EndPoint',
    licensePlateDoesntExist:'Placa não existe',
    licensePlateAlreadyInserted:'Placa já inserida abaixo',
    groupDisabled: 'Grupo desabilitado com sucesso!',
    groupSaved: 'Novo grupo adicionado com sucesso!',
    getGroupsError: 'Erro ao recuperar informaçãoes do Grupo.',
    getSubgroupsError: 'Erro ao recuperar informaçãoes do Subgrupo.',
    getItemsTesisError: 'Erro ao recuperar informaçãoes dos Itens.',
    itemSaved: 'Novo Item adicionado com sucesso!',
    userDisabled: 'Usuário desabilitado com sucesso!',
    anomalySaved: 'Nova Anomalia adicionada com sucesso!',
    groupNotHaveSubgroup: 'O grupo selecionado não possui subgrupos, favor selecionar outro grupo!',
    getAnomalyTesisError: 'Erro ao recuperar as Anomalias.',
    selectGroupToAddNewInfo: 'Clique na descrição do Grupo para adicionar novas informações.',
    confirmDeleteItem: 'Tem certeza que deseja remover o item: ',
    itemRemoved: 'Item removido com sucesso!',
    confirmDeleteAnomaly: 'Tem certeza que deseja remover a anomalia: ',
    anomalyRemoved: 'Anomalia removida com sucesso!',
    experienceReviewed: 'Experiência revisada com sucesso!',
    experienceCanceled: 'Experiência cancelada com sucesso!',
    confirmCancelExperience: 'Tem certeza que deseja cancelar a Experiência de Usuário? ',
    timeOutError: 'Não foi possível acessar o servidor. \nVerifique sua conexão com a internet.'
};

export const alertLabels = {
    iconAlert: "exclamation-triangle",
    iconError: "times",
    iconInfo: "info-circle",
    iconSuccess: "check",
    alertWarning: "warning",
    alertDanger:"danger",
    alertInfo: "info",
    alertSuccess: "success"
};

export const files = {
    experienceFile: 'Experiences_',
    CSVSeparator: ';',
    CSVFile: '.csv'
};

export const keyTokenLogin = "tokenLoginBrainFCA";
export const userLogin = "userLogin";
export const userNameLogin = "userNameLogin";

export const profileTypes = {
    designated: 'DESIGNADO',
    at: 'AT',
    radar: 'RADAR',
};

export const marketTypes = {
    brazil: 'Brasil',
    argentina: 'Argentina',
};

export const statusTypes = {
    active: 'Ativo',
    inactive: 'Inativo',
    received: 'Recebido',
    sent: 'Enviado',
    reviewed: 'Revisado',
    canceled: 'Cancelado',
    inconsistent: 'Inconsistente',
};

export const formTitles = {
    profile: 'Perfil',
    car: 'Carros',
    market: 'Mercado',
    plates: 'Placas',
};

export const active = 0;
export const inactive = 1;

export const typeFilterDate = {
    creation: 'creation_date',
    update: 'update_date'
};


// WEBPACK FOOTER //
// ./src/util/constants.js